import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { ROUTE_DISCOVER_QUESTIONNAIRE, ROUTE_DISCOVER_RESULT } from 'RouteList';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';
import Button from 'components/Button/Button';
import { Flex } from 'components/Layout/Layout';
import P from '../../components/P/P';
import { useStores } from '../../store/useStores';

function Intro() {
  const { routing } = useStores();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { push } = routing;

  return (
    <BasePage>
      <Content verticalcenter>
        <Flex mb={4} width={1}>
          <P textcenter>
            <FormattedMessage {...messages.discoverQuestionnaireDescription} />
          </P>
        </Flex>
        <Flex mb={4} width={1}>
          <Button
            full
            primary
            onClick={() => push(ROUTE_DISCOVER_QUESTIONNAIRE)}
          >
            <FormattedMessage {...messages.discoverQuestionnaire} />
          </Button>
        </Flex>
        <Flex mb={4} width={1}>
          <P textcenter>
            <FormattedMessage {...messages.discoverResultDescription} />
          </P>
        </Flex>
        <Flex mb={4} width={1}>
          <Button full primary onClick={() => push(ROUTE_DISCOVER_RESULT)}>
            <FormattedMessage {...messages.discoverResult} />
          </Button>
        </Flex>
      </Content>
    </BasePage>
  );
}

export default observer(Intro);
